import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91categoryPackSlug_93z27i6uRLNRMeta } from "/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue?macro=true";
import { default as index73ub6BpJDLMeta } from "/app/pages/[gameSlug]/[gamePackSlug]/index.vue?macro=true";
import { default as boostersUm1POiI8GeMeta } from "/app/pages/[gameSlug]/boosters.vue?macro=true";
import { default as e_45learningoBuXh6gxcAMeta } from "/app/pages/[gameSlug]/e-learning.vue?macro=true";
import { default as index7tUBh2UhAHMeta } from "/app/pages/[gameSlug]/index.vue?macro=true";
import { default as _404STh7p7T7N0Meta } from "/app/pages/404.vue?macro=true";
import { default as _91gameSlug_93UFMV6uSl4wMeta } from "/app/pages/apply-for-us/[gameSlug].vue?macro=true";
import { default as _91blogSlug_93ZJPoZkZUNDMeta } from "/app/pages/blog/[blogSlug].vue?macro=true";
import { default as BlogswJ60zFSM48Meta } from "/app/pages/Blogs.vue?macro=true";
import { default as _91ruleSlug_933gWQdYvG6JMeta } from "/app/pages/booster-rule/[ruleSlug].vue?macro=true";
import { default as booster_45ruleGUCoSgMaZnMeta } from "/app/pages/booster-rule.vue?macro=true";
import { default as booster_45rulesU7mgVkP1r2Meta } from "/app/pages/booster-rules.vue?macro=true";
import { default as _91boosterId_93skhPLKKaKoMeta } from "/app/pages/booster/[boosterId].vue?macro=true";
import { default as GameFetcherNt6euBWiCuMeta } from "/app/pages/booster/GameFetcher.vue?macro=true";
import { default as SellerOffersGHYKLJ3haOMeta } from "/app/pages/booster/SellerOffers.vue?macro=true";
import { default as _91invoiceCode_936ULS3nhIe5Meta } from "/app/pages/checkout/[invoiceCode].vue?macro=true";
import { default as contactV6oPJjs9RyMeta } from "/app/pages/contact.vue?macro=true";
import { default as _91ruleSlug_935AOQkp3LmqMeta } from "/app/pages/customer-rule/[ruleSlug].vue?macro=true";
import { default as customer_45ruleGr0FX0HCclMeta } from "/app/pages/customer-rule.vue?macro=true";
import { default as customer_45rulesWZZOqtOEx7Meta } from "/app/pages/customer-rules.vue?macro=true";
import { default as connected_45accounts3JQLPStIXNMeta } from "/app/pages/dashboard/account-settings/connected-accounts.vue?macro=true";
import { default as gold9S2aWavblNMeta } from "/app/pages/dashboard/account-settings/gold.vue?macro=true";
import { default as levelsqO7Fdd7YCWMeta } from "/app/pages/dashboard/account-settings/levels.vue?macro=true";
import { default as my_45account4XPr1zVDYeMeta } from "/app/pages/dashboard/account-settings/my-account.vue?macro=true";
import { default as my_45membership48vydn1ZaYMeta } from "/app/pages/dashboard/account-settings/my-membership.vue?macro=true";
import { default as my_45qrcodeWipEv6wsfDMeta } from "/app/pages/dashboard/account-settings/my-qrcode.vue?macro=true";
import { default as raidWMs6hrxDXRMeta } from "/app/pages/dashboard/account-settings/raid.vue?macro=true";
import { default as account_45settingssCicztGnokMeta } from "/app/pages/dashboard/account-settings.vue?macro=true";
import { default as _91requestId_93g0gcmA3MFBMeta } from "/app/pages/dashboard/admin-applications/[requestId].vue?macro=true";
import { default as indexLVkEiPVkLLMeta } from "/app/pages/dashboard/admin-applications/index.vue?macro=true";
import { default as _91status_93AG7b1CxI46Meta } from "/app/pages/dashboard/admin-bankroll/[userId]/[status].vue?macro=true";
import { default as admin_45blog480krxb330Meta } from "/app/pages/dashboard/admin-blog.vue?macro=true";
import { default as admin_45couponswZdMIYZv1nMeta } from "/app/pages/dashboard/admin-coupons.vue?macro=true";
import { default as admin_45game_45seasonsgcpIcJYZa3Meta } from "/app/pages/dashboard/admin-game-seasons.vue?macro=true";
import { default as admin_45logsgzHO8dn7KMMeta } from "/app/pages/dashboard/admin-logs.vue?macro=true";
import { default as admin_45payout9zRotDcsW5Meta } from "/app/pages/dashboard/admin-payout.vue?macro=true";
import { default as admin_45user_45missing_45infoKbJoG5BUhpMeta } from "/app/pages/dashboard/admin-user-missing-info.vue?macro=true";
import { default as admin_45usersSaqSw8v7rAMeta } from "/app/pages/dashboard/admin-users.vue?macro=true";
import { default as bankrollIXXYpCTT9tMeta } from "/app/pages/dashboard/bankroll.vue?macro=true";
import { default as cashbackj9xLNvqGZJMeta } from "/app/pages/dashboard/cashback.vue?macro=true";
import { default as contact_45requestsIlllfYP3BRMeta } from "/app/pages/dashboard/contact-requests.vue?macro=true";
import { default as indexhg2nWJrbRRMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as _91slug_93NsvpltuG43Meta } from "/app/pages/dashboard/job-applications/[slug].vue?macro=true";
import { default as indexVNjjcGZAndMeta } from "/app/pages/dashboard/job-applications/index.vue?macro=true";
import { default as job_45applicationsM6A7yqAKv1Meta } from "/app/pages/dashboard/job-applications.vue?macro=true";
import { default as _91invoiceCode_93Gkaf9unp4fMeta } from "/app/pages/dashboard/orders/[invoiceCode].vue?macro=true";
import { default as index2tHatxspqcMeta } from "/app/pages/dashboard/orders/index.vue?macro=true";
import { default as _91raid_93fktTnM7vb9Meta } from "/app/pages/dashboard/raid-orders/[date]/[raid].vue?macro=true";
import { default as indexcJztBknFy9Meta } from "/app/pages/dashboard/raid-orders/index.vue?macro=true";
import { default as admin_45goldaU8fc2VapkMeta } from "/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue?macro=true";
import { default as admin_45ip_45logsqxtTXqY1AjMeta } from "/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue?macro=true";
import { default as admin_45levelsHkZdsNzffNMeta } from "/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue?macro=true";
import { default as admin_45raid_45calenderLe4hPFZFL9Meta } from "/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue?macro=true";
import { default as user_45accountvJ3OgBfyFIMeta } from "/app/pages/dashboard/user-account-settings/[userId]/user-account.vue?macro=true";
import { default as user_45booster_45optionscRVj0PYmK9Meta } from "/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue?macro=true";
import { default as user_45booster_45profileDfGwWSAzC1Meta } from "/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue?macro=true";
import { default as user_45connected_45accountsnyrGC4TIbNMeta } from "/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue?macro=true";
import { default as user_45membershipxMkSzFwqEAMeta } from "/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue?macro=true";
import { default as user_45securityqXUHCXG95oMeta } from "/app/pages/dashboard/user-account-settings/[userId]/user-security.vue?macro=true";
import { default as user_45verificationkfFJhUf1cXMeta } from "/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue?macro=true";
import { default as user_45walletIqsgnPRxngMeta } from "/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue?macro=true";
import { default as user_45account_45settingsLd7K15ZzspMeta } from "/app/pages/dashboard/user-account-settings.vue?macro=true";
import { default as _91code_93AxIx7d4360Meta } from "/app/pages/dashboard/verification/[code].vue?macro=true";
import { default as indexaIurtgxbffMeta } from "/app/pages/dashboard/verification/index.vue?macro=true";
import { default as error_45page_45paymentxGcS47fXOJMeta } from "/app/pages/error-page-payment.vue?macro=true";
import { default as _91boosterId_930oZYfcOhHTMeta } from "/app/pages/gold-seller/[boosterId].vue?macro=true";
import { default as link_45discordUagKM3akRfMeta } from "/app/pages/link-discord.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as membership_45checkout_45magiccQtY61111sMeta } from "/app/pages/membership-checkout-magic.vue?macro=true";
import { default as membership_45checkoutM4b6a2wcZNMeta } from "/app/pages/membership-checkout.vue?macro=true";
import { default as membershipWWFsX1R3saMeta } from "/app/pages/membership.vue?macro=true";
import { default as payment_45failedfyVjkMyN2QMeta } from "/app/pages/payment-failed.vue?macro=true";
import { default as payment_45successxSyLRJqw0cMeta } from "/app/pages/payment-success.vue?macro=true";
import { default as refund_45policyWeRYySghLcMeta } from "/app/pages/refund-policy.vue?macro=true";
import { default as trustpilot_45review1LZO0tWtVGMeta } from "/app/pages/trustpilot-review.vue?macro=true";
import { default as applylgoRnC39vRMeta } from "/app/pages/work-with-us/[slug]/apply.vue?macro=true";
import { default as indexLmszu812hPMeta } from "/app/pages/work-with-us/[slug]/index.vue?macro=true";
import { default as indexJZF1QpkjHuMeta } from "/app/pages/work-with-us/index.vue?macro=true";
export default [
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___en",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/en/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___it",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/it/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___de",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/de/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___es",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/es/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___fr",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/fr/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___nl",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/nl/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___pt",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/pt/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___ru",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/ru/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: _91categoryPackSlug_93z27i6uRLNRMeta?.name ?? "gameSlug-gamePackSlug-categoryPackSlug___uk",
    path: _91categoryPackSlug_93z27i6uRLNRMeta?.path ?? "/uk/:gameSlug()/:gamePackSlug()/:categoryPackSlug()",
    meta: _91categoryPackSlug_93z27i6uRLNRMeta || {},
    alias: _91categoryPackSlug_93z27i6uRLNRMeta?.alias || [],
    redirect: _91categoryPackSlug_93z27i6uRLNRMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/[categoryPackSlug].vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___en",
    path: index73ub6BpJDLMeta?.path ?? "/en/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___it",
    path: index73ub6BpJDLMeta?.path ?? "/it/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___de",
    path: index73ub6BpJDLMeta?.path ?? "/de/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___es",
    path: index73ub6BpJDLMeta?.path ?? "/es/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___fr",
    path: index73ub6BpJDLMeta?.path ?? "/fr/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___nl",
    path: index73ub6BpJDLMeta?.path ?? "/nl/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___pt",
    path: index73ub6BpJDLMeta?.path ?? "/pt/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___ru",
    path: index73ub6BpJDLMeta?.path ?? "/ru/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index73ub6BpJDLMeta?.name ?? "gameSlug-gamePackSlug___uk",
    path: index73ub6BpJDLMeta?.path ?? "/uk/:gameSlug()/:gamePackSlug()",
    meta: index73ub6BpJDLMeta || {},
    alias: index73ub6BpJDLMeta?.alias || [],
    redirect: index73ub6BpJDLMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/[gamePackSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___en",
    path: boostersUm1POiI8GeMeta?.path ?? "/en/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___it",
    path: boostersUm1POiI8GeMeta?.path ?? "/it/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___de",
    path: boostersUm1POiI8GeMeta?.path ?? "/de/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___es",
    path: boostersUm1POiI8GeMeta?.path ?? "/es/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___fr",
    path: boostersUm1POiI8GeMeta?.path ?? "/fr/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___nl",
    path: boostersUm1POiI8GeMeta?.path ?? "/nl/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___pt",
    path: boostersUm1POiI8GeMeta?.path ?? "/pt/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___ru",
    path: boostersUm1POiI8GeMeta?.path ?? "/ru/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: boostersUm1POiI8GeMeta?.name ?? "gameSlug-boosters___uk",
    path: boostersUm1POiI8GeMeta?.path ?? "/uk/:gameSlug()/boosters",
    meta: boostersUm1POiI8GeMeta || {},
    alias: boostersUm1POiI8GeMeta?.alias || [],
    redirect: boostersUm1POiI8GeMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/boosters.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___en",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/en/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___it",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/it/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___de",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/de/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___es",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/es/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___fr",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/fr/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___nl",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/nl/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___pt",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/pt/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___ru",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/ru/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: e_45learningoBuXh6gxcAMeta?.name ?? "gameSlug-e-learning___uk",
    path: e_45learningoBuXh6gxcAMeta?.path ?? "/uk/:gameSlug()/e-learning",
    meta: e_45learningoBuXh6gxcAMeta || {},
    alias: e_45learningoBuXh6gxcAMeta?.alias || [],
    redirect: e_45learningoBuXh6gxcAMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/e-learning.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___en",
    path: index7tUBh2UhAHMeta?.path ?? "/en/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___it",
    path: index7tUBh2UhAHMeta?.path ?? "/it/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___de",
    path: index7tUBh2UhAHMeta?.path ?? "/de/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___es",
    path: index7tUBh2UhAHMeta?.path ?? "/es/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___fr",
    path: index7tUBh2UhAHMeta?.path ?? "/fr/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___nl",
    path: index7tUBh2UhAHMeta?.path ?? "/nl/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___pt",
    path: index7tUBh2UhAHMeta?.path ?? "/pt/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___ru",
    path: index7tUBh2UhAHMeta?.path ?? "/ru/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: index7tUBh2UhAHMeta?.name ?? "gameSlug___uk",
    path: index7tUBh2UhAHMeta?.path ?? "/uk/:gameSlug()",
    meta: index7tUBh2UhAHMeta || {},
    alias: index7tUBh2UhAHMeta?.alias || [],
    redirect: index7tUBh2UhAHMeta?.redirect,
    component: () => import("/app/pages/[gameSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___en",
    path: _404STh7p7T7N0Meta?.path ?? "/en/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___it",
    path: _404STh7p7T7N0Meta?.path ?? "/it/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___de",
    path: _404STh7p7T7N0Meta?.path ?? "/de/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___es",
    path: _404STh7p7T7N0Meta?.path ?? "/es/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___fr",
    path: _404STh7p7T7N0Meta?.path ?? "/fr/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___nl",
    path: _404STh7p7T7N0Meta?.path ?? "/nl/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___pt",
    path: _404STh7p7T7N0Meta?.path ?? "/pt/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___ru",
    path: _404STh7p7T7N0Meta?.path ?? "/ru/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404STh7p7T7N0Meta?.name ?? "404___uk",
    path: _404STh7p7T7N0Meta?.path ?? "/uk/404",
    meta: _404STh7p7T7N0Meta || {},
    alias: _404STh7p7T7N0Meta?.alias || [],
    redirect: _404STh7p7T7N0Meta?.redirect,
    component: () => import("/app/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___en",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/en/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___it",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/it/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___de",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/de/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___es",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/es/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___fr",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/fr/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___nl",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/nl/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___pt",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/pt/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___ru",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/ru/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91gameSlug_93UFMV6uSl4wMeta?.name ?? "apply-for-us-gameSlug___uk",
    path: _91gameSlug_93UFMV6uSl4wMeta?.path ?? "/uk/apply-for-us/:gameSlug()",
    meta: _91gameSlug_93UFMV6uSl4wMeta || {},
    alias: _91gameSlug_93UFMV6uSl4wMeta?.alias || [],
    redirect: _91gameSlug_93UFMV6uSl4wMeta?.redirect,
    component: () => import("/app/pages/apply-for-us/[gameSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___en",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/en/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___it",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/it/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___de",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/de/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___es",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/es/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___fr",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/fr/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___nl",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/nl/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___pt",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/pt/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___ru",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/ru/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: _91blogSlug_93ZJPoZkZUNDMeta?.name ?? "blog-blogSlug___uk",
    path: _91blogSlug_93ZJPoZkZUNDMeta?.path ?? "/uk/blog/:blogSlug()",
    meta: _91blogSlug_93ZJPoZkZUNDMeta || {},
    alias: _91blogSlug_93ZJPoZkZUNDMeta?.alias || [],
    redirect: _91blogSlug_93ZJPoZkZUNDMeta?.redirect,
    component: () => import("/app/pages/blog/[blogSlug].vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___en",
    path: BlogswJ60zFSM48Meta?.path ?? "/en/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___it",
    path: BlogswJ60zFSM48Meta?.path ?? "/it/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___de",
    path: BlogswJ60zFSM48Meta?.path ?? "/de/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___es",
    path: BlogswJ60zFSM48Meta?.path ?? "/es/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___fr",
    path: BlogswJ60zFSM48Meta?.path ?? "/fr/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___nl",
    path: BlogswJ60zFSM48Meta?.path ?? "/nl/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___pt",
    path: BlogswJ60zFSM48Meta?.path ?? "/pt/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___ru",
    path: BlogswJ60zFSM48Meta?.path ?? "/ru/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: BlogswJ60zFSM48Meta?.name ?? "Blogs___uk",
    path: BlogswJ60zFSM48Meta?.path ?? "/uk/Blogs",
    meta: BlogswJ60zFSM48Meta || {},
    alias: BlogswJ60zFSM48Meta?.alias || [],
    redirect: BlogswJ60zFSM48Meta?.redirect,
    component: () => import("/app/pages/Blogs.vue").then(m => m.default || m)
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___en",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/en/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___en",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___it",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/it/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___it",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___de",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/de/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___de",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___es",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/es/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___es",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___fr",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/fr/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___fr",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___nl",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/nl/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___nl",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___pt",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/pt/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___pt",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___ru",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/ru/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___ru",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45ruleGUCoSgMaZnMeta?.name ?? "booster-rule___uk",
    path: booster_45ruleGUCoSgMaZnMeta?.path ?? "/uk/booster-rule",
    meta: booster_45ruleGUCoSgMaZnMeta || {},
    alias: booster_45ruleGUCoSgMaZnMeta?.alias || [],
    redirect: booster_45ruleGUCoSgMaZnMeta?.redirect,
    component: () => import("/app/pages/booster-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_933gWQdYvG6JMeta?.name ?? "booster-rule-ruleSlug___uk",
    path: _91ruleSlug_933gWQdYvG6JMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_933gWQdYvG6JMeta || {},
    alias: _91ruleSlug_933gWQdYvG6JMeta?.alias || [],
    redirect: _91ruleSlug_933gWQdYvG6JMeta?.redirect,
    component: () => import("/app/pages/booster-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___en",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/en/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___it",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/it/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___de",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/de/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___es",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/es/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___fr",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/fr/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___nl",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/nl/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___pt",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/pt/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___ru",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/ru/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: booster_45rulesU7mgVkP1r2Meta?.name ?? "booster-rules___uk",
    path: booster_45rulesU7mgVkP1r2Meta?.path ?? "/uk/booster-rules",
    meta: booster_45rulesU7mgVkP1r2Meta || {},
    alias: booster_45rulesU7mgVkP1r2Meta?.alias || [],
    redirect: booster_45rulesU7mgVkP1r2Meta?.redirect,
    component: () => import("/app/pages/booster-rules.vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___en",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/en/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___it",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/it/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___de",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/de/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___es",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/es/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___fr",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/fr/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___nl",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/nl/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___pt",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/pt/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___ru",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/ru/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_93skhPLKKaKoMeta?.name ?? "booster-boosterId___uk",
    path: _91boosterId_93skhPLKKaKoMeta?.path ?? "/uk/booster/:boosterId()",
    meta: _91boosterId_93skhPLKKaKoMeta || {},
    alias: _91boosterId_93skhPLKKaKoMeta?.alias || [],
    redirect: _91boosterId_93skhPLKKaKoMeta?.redirect,
    component: () => import("/app/pages/booster/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___en",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/en/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___it",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/it/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___de",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/de/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___es",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/es/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___fr",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/fr/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___nl",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/nl/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___pt",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/pt/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___ru",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/ru/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: GameFetcherNt6euBWiCuMeta?.name ?? "booster-GameFetcher___uk",
    path: GameFetcherNt6euBWiCuMeta?.path ?? "/uk/booster/GameFetcher",
    meta: GameFetcherNt6euBWiCuMeta || {},
    alias: GameFetcherNt6euBWiCuMeta?.alias || [],
    redirect: GameFetcherNt6euBWiCuMeta?.redirect,
    component: () => import("/app/pages/booster/GameFetcher.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___en",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/en/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___it",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/it/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___de",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/de/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___es",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/es/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___fr",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/fr/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___nl",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/nl/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___pt",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/pt/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___ru",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/ru/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: SellerOffersGHYKLJ3haOMeta?.name ?? "booster-SellerOffers___uk",
    path: SellerOffersGHYKLJ3haOMeta?.path ?? "/uk/booster/SellerOffers",
    meta: SellerOffersGHYKLJ3haOMeta || {},
    alias: SellerOffersGHYKLJ3haOMeta?.alias || [],
    redirect: SellerOffersGHYKLJ3haOMeta?.redirect,
    component: () => import("/app/pages/booster/SellerOffers.vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___en",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/en/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___it",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/it/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___de",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/de/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___es",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/es/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___fr",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/fr/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___nl",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/nl/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___pt",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/pt/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___ru",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/ru/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_936ULS3nhIe5Meta?.name ?? "checkout-invoiceCode___uk",
    path: _91invoiceCode_936ULS3nhIe5Meta?.path ?? "/uk/checkout/:invoiceCode()",
    meta: _91invoiceCode_936ULS3nhIe5Meta || {},
    alias: _91invoiceCode_936ULS3nhIe5Meta?.alias || [],
    redirect: _91invoiceCode_936ULS3nhIe5Meta?.redirect,
    component: () => import("/app/pages/checkout/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___en",
    path: contactV6oPJjs9RyMeta?.path ?? "/en/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___it",
    path: contactV6oPJjs9RyMeta?.path ?? "/it/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___de",
    path: contactV6oPJjs9RyMeta?.path ?? "/de/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___es",
    path: contactV6oPJjs9RyMeta?.path ?? "/es/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___fr",
    path: contactV6oPJjs9RyMeta?.path ?? "/fr/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___nl",
    path: contactV6oPJjs9RyMeta?.path ?? "/nl/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___pt",
    path: contactV6oPJjs9RyMeta?.path ?? "/pt/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___ru",
    path: contactV6oPJjs9RyMeta?.path ?? "/ru/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___uk",
    path: contactV6oPJjs9RyMeta?.path ?? "/uk/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___en",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/en/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___en",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___it",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/it/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___it",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___de",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/de/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___de",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___es",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/es/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___es",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___fr",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/fr/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___fr",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___nl",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/nl/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___nl",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___pt",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/pt/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___pt",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___ru",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/ru/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___ru",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45ruleGr0FX0HCclMeta?.name ?? "customer-rule___uk",
    path: customer_45ruleGr0FX0HCclMeta?.path ?? "/uk/customer-rule",
    meta: customer_45ruleGr0FX0HCclMeta || {},
    alias: customer_45ruleGr0FX0HCclMeta?.alias || [],
    redirect: customer_45ruleGr0FX0HCclMeta?.redirect,
    component: () => import("/app/pages/customer-rule.vue").then(m => m.default || m),
    children: [
  {
    name: _91ruleSlug_935AOQkp3LmqMeta?.name ?? "customer-rule-ruleSlug___uk",
    path: _91ruleSlug_935AOQkp3LmqMeta?.path ?? ":ruleSlug()",
    meta: _91ruleSlug_935AOQkp3LmqMeta || {},
    alias: _91ruleSlug_935AOQkp3LmqMeta?.alias || [],
    redirect: _91ruleSlug_935AOQkp3LmqMeta?.redirect,
    component: () => import("/app/pages/customer-rule/[ruleSlug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___en",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/en/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___it",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/it/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___de",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/de/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___es",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/es/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___fr",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/fr/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___nl",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/nl/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___pt",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/pt/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___ru",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/ru/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: customer_45rulesWZZOqtOEx7Meta?.name ?? "customer-rules___uk",
    path: customer_45rulesWZZOqtOEx7Meta?.path ?? "/uk/customer-rules",
    meta: customer_45rulesWZZOqtOEx7Meta || {},
    alias: customer_45rulesWZZOqtOEx7Meta?.alias || [],
    redirect: customer_45rulesWZZOqtOEx7Meta?.redirect,
    component: () => import("/app/pages/customer-rules.vue").then(m => m.default || m)
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___en",
    path: account_45settingssCicztGnokMeta?.path ?? "/en/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___en",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___en",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___en",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___en",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___en",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___en",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___en",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___it",
    path: account_45settingssCicztGnokMeta?.path ?? "/it/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___it",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___it",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___it",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___it",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___it",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___it",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___it",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___de",
    path: account_45settingssCicztGnokMeta?.path ?? "/de/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___de",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___de",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___de",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___de",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___de",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___de",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___de",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___es",
    path: account_45settingssCicztGnokMeta?.path ?? "/es/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___es",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___es",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___es",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___es",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___es",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___es",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___es",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___fr",
    path: account_45settingssCicztGnokMeta?.path ?? "/fr/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___fr",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___fr",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___fr",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___fr",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___fr",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___fr",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___fr",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___nl",
    path: account_45settingssCicztGnokMeta?.path ?? "/nl/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___nl",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___nl",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___nl",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___nl",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___nl",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___nl",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___nl",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___pt",
    path: account_45settingssCicztGnokMeta?.path ?? "/pt/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___pt",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___pt",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___pt",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___pt",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___pt",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___pt",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___pt",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___ru",
    path: account_45settingssCicztGnokMeta?.path ?? "/ru/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___ru",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___ru",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___ru",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___ru",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___ru",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___ru",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___ru",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45settingssCicztGnokMeta?.name ?? "dashboard-account-settings___uk",
    path: account_45settingssCicztGnokMeta?.path ?? "/uk/dashboard/account-settings",
    meta: account_45settingssCicztGnokMeta || {},
    alias: account_45settingssCicztGnokMeta?.alias || [],
    redirect: account_45settingssCicztGnokMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: connected_45accounts3JQLPStIXNMeta?.name ?? "dashboard-account-settings-connected-accounts___uk",
    path: connected_45accounts3JQLPStIXNMeta?.path ?? "connected-accounts",
    meta: connected_45accounts3JQLPStIXNMeta || {},
    alias: connected_45accounts3JQLPStIXNMeta?.alias || [],
    redirect: connected_45accounts3JQLPStIXNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: gold9S2aWavblNMeta?.name ?? "dashboard-account-settings-gold___uk",
    path: gold9S2aWavblNMeta?.path ?? "gold",
    meta: gold9S2aWavblNMeta || {},
    alias: gold9S2aWavblNMeta?.alias || [],
    redirect: gold9S2aWavblNMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/gold.vue").then(m => m.default || m)
  },
  {
    name: levelsqO7Fdd7YCWMeta?.name ?? "dashboard-account-settings-levels___uk",
    path: levelsqO7Fdd7YCWMeta?.path ?? "levels",
    meta: levelsqO7Fdd7YCWMeta || {},
    alias: levelsqO7Fdd7YCWMeta?.alias || [],
    redirect: levelsqO7Fdd7YCWMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/levels.vue").then(m => m.default || m)
  },
  {
    name: my_45account4XPr1zVDYeMeta?.name ?? "dashboard-account-settings-my-account___uk",
    path: my_45account4XPr1zVDYeMeta?.path ?? "my-account",
    meta: my_45account4XPr1zVDYeMeta || {},
    alias: my_45account4XPr1zVDYeMeta?.alias || [],
    redirect: my_45account4XPr1zVDYeMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-account.vue").then(m => m.default || m)
  },
  {
    name: my_45membership48vydn1ZaYMeta?.name ?? "dashboard-account-settings-my-membership___uk",
    path: my_45membership48vydn1ZaYMeta?.path ?? "my-membership",
    meta: my_45membership48vydn1ZaYMeta || {},
    alias: my_45membership48vydn1ZaYMeta?.alias || [],
    redirect: my_45membership48vydn1ZaYMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-membership.vue").then(m => m.default || m)
  },
  {
    name: my_45qrcodeWipEv6wsfDMeta?.name ?? "dashboard-account-settings-my-qrcode___uk",
    path: my_45qrcodeWipEv6wsfDMeta?.path ?? "my-qrcode",
    meta: my_45qrcodeWipEv6wsfDMeta || {},
    alias: my_45qrcodeWipEv6wsfDMeta?.alias || [],
    redirect: my_45qrcodeWipEv6wsfDMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/my-qrcode.vue").then(m => m.default || m)
  },
  {
    name: raidWMs6hrxDXRMeta?.name ?? "dashboard-account-settings-raid___uk",
    path: raidWMs6hrxDXRMeta?.path ?? "raid",
    meta: raidWMs6hrxDXRMeta || {},
    alias: raidWMs6hrxDXRMeta?.alias || [],
    redirect: raidWMs6hrxDXRMeta?.redirect,
    component: () => import("/app/pages/dashboard/account-settings/raid.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___en",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/en/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___it",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/it/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___de",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/de/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___es",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/es/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___fr",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/fr/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___nl",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/nl/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___pt",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/pt/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___ru",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/ru/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: _91requestId_93g0gcmA3MFBMeta?.name ?? "dashboard-admin-applications-requestId___uk",
    path: _91requestId_93g0gcmA3MFBMeta?.path ?? "/uk/dashboard/admin-applications/:requestId()",
    meta: _91requestId_93g0gcmA3MFBMeta || {},
    alias: _91requestId_93g0gcmA3MFBMeta?.alias || [],
    redirect: _91requestId_93g0gcmA3MFBMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/[requestId].vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___en",
    path: indexLVkEiPVkLLMeta?.path ?? "/en/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___it",
    path: indexLVkEiPVkLLMeta?.path ?? "/it/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___de",
    path: indexLVkEiPVkLLMeta?.path ?? "/de/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___es",
    path: indexLVkEiPVkLLMeta?.path ?? "/es/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___fr",
    path: indexLVkEiPVkLLMeta?.path ?? "/fr/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___nl",
    path: indexLVkEiPVkLLMeta?.path ?? "/nl/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___pt",
    path: indexLVkEiPVkLLMeta?.path ?? "/pt/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___ru",
    path: indexLVkEiPVkLLMeta?.path ?? "/ru/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: indexLVkEiPVkLLMeta?.name ?? "dashboard-admin-applications___uk",
    path: indexLVkEiPVkLLMeta?.path ?? "/uk/dashboard/admin-applications",
    meta: indexLVkEiPVkLLMeta || {},
    alias: indexLVkEiPVkLLMeta?.alias || [],
    redirect: indexLVkEiPVkLLMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-applications/index.vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___en",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/en/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___it",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/it/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___de",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/de/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___es",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/es/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___fr",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/fr/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___nl",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/nl/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___pt",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/pt/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___ru",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/ru/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: _91status_93AG7b1CxI46Meta?.name ?? "dashboard-admin-bankroll-userId-status___uk",
    path: _91status_93AG7b1CxI46Meta?.path ?? "/uk/dashboard/admin-bankroll/:userId()/:status()",
    meta: _91status_93AG7b1CxI46Meta || {},
    alias: _91status_93AG7b1CxI46Meta?.alias || [],
    redirect: _91status_93AG7b1CxI46Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-bankroll/[userId]/[status].vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___en",
    path: admin_45blog480krxb330Meta?.path ?? "/en/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___it",
    path: admin_45blog480krxb330Meta?.path ?? "/it/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___de",
    path: admin_45blog480krxb330Meta?.path ?? "/de/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___es",
    path: admin_45blog480krxb330Meta?.path ?? "/es/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___fr",
    path: admin_45blog480krxb330Meta?.path ?? "/fr/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___nl",
    path: admin_45blog480krxb330Meta?.path ?? "/nl/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___pt",
    path: admin_45blog480krxb330Meta?.path ?? "/pt/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___ru",
    path: admin_45blog480krxb330Meta?.path ?? "/ru/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45blog480krxb330Meta?.name ?? "dashboard-admin-blog___uk",
    path: admin_45blog480krxb330Meta?.path ?? "/uk/dashboard/admin-blog",
    meta: admin_45blog480krxb330Meta || {},
    alias: admin_45blog480krxb330Meta?.alias || [],
    redirect: admin_45blog480krxb330Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-blog.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___en",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/en/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___it",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/it/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___de",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/de/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___es",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/es/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___fr",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/fr/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___nl",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/nl/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___pt",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/pt/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___ru",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/ru/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45couponswZdMIYZv1nMeta?.name ?? "dashboard-admin-coupons___uk",
    path: admin_45couponswZdMIYZv1nMeta?.path ?? "/uk/dashboard/admin-coupons",
    meta: admin_45couponswZdMIYZv1nMeta || {},
    alias: admin_45couponswZdMIYZv1nMeta?.alias || [],
    redirect: admin_45couponswZdMIYZv1nMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-coupons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___en",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/en/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___it",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/it/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___de",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/de/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___es",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/es/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___fr",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/fr/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___nl",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/nl/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___pt",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/pt/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___ru",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/ru/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45game_45seasonsgcpIcJYZa3Meta?.name ?? "dashboard-admin-game-seasons___uk",
    path: admin_45game_45seasonsgcpIcJYZa3Meta?.path ?? "/uk/dashboard/admin-game-seasons",
    meta: admin_45game_45seasonsgcpIcJYZa3Meta || {},
    alias: admin_45game_45seasonsgcpIcJYZa3Meta?.alias || [],
    redirect: admin_45game_45seasonsgcpIcJYZa3Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-game-seasons.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___en",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/en/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___it",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/it/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___de",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/de/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___es",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/es/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___fr",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/fr/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___nl",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/nl/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___pt",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/pt/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___ru",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/ru/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45logsgzHO8dn7KMMeta?.name ?? "dashboard-admin-logs___uk",
    path: admin_45logsgzHO8dn7KMMeta?.path ?? "/uk/dashboard/admin-logs",
    meta: admin_45logsgzHO8dn7KMMeta || {},
    alias: admin_45logsgzHO8dn7KMMeta?.alias || [],
    redirect: admin_45logsgzHO8dn7KMMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___en",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/en/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___it",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/it/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___de",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/de/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___es",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/es/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___fr",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/fr/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___nl",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/nl/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___pt",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/pt/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___ru",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/ru/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45payout9zRotDcsW5Meta?.name ?? "dashboard-admin-payout___uk",
    path: admin_45payout9zRotDcsW5Meta?.path ?? "/uk/dashboard/admin-payout",
    meta: admin_45payout9zRotDcsW5Meta || {},
    alias: admin_45payout9zRotDcsW5Meta?.alias || [],
    redirect: admin_45payout9zRotDcsW5Meta?.redirect,
    component: () => import("/app/pages/dashboard/admin-payout.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___en",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/en/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___it",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/it/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___de",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/de/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___es",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/es/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___fr",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/fr/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___nl",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/nl/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___pt",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/pt/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___ru",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/ru/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45user_45missing_45infoKbJoG5BUhpMeta?.name ?? "dashboard-admin-user-missing-info___uk",
    path: admin_45user_45missing_45infoKbJoG5BUhpMeta?.path ?? "/uk/dashboard/admin-user-missing-info",
    meta: admin_45user_45missing_45infoKbJoG5BUhpMeta || {},
    alias: admin_45user_45missing_45infoKbJoG5BUhpMeta?.alias || [],
    redirect: admin_45user_45missing_45infoKbJoG5BUhpMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-user-missing-info.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___en",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/en/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___it",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/it/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___de",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/de/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___es",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/es/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___fr",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/fr/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___nl",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/nl/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___pt",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/pt/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___ru",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/ru/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: admin_45usersSaqSw8v7rAMeta?.name ?? "dashboard-admin-users___uk",
    path: admin_45usersSaqSw8v7rAMeta?.path ?? "/uk/dashboard/admin-users",
    meta: admin_45usersSaqSw8v7rAMeta || {},
    alias: admin_45usersSaqSw8v7rAMeta?.alias || [],
    redirect: admin_45usersSaqSw8v7rAMeta?.redirect,
    component: () => import("/app/pages/dashboard/admin-users.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___en",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/en/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___it",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/it/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___de",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/de/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___es",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/es/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___fr",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/fr/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___nl",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/nl/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___pt",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/pt/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___ru",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/ru/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: bankrollIXXYpCTT9tMeta?.name ?? "dashboard-bankroll___uk",
    path: bankrollIXXYpCTT9tMeta?.path ?? "/uk/dashboard/bankroll",
    meta: bankrollIXXYpCTT9tMeta || {},
    alias: bankrollIXXYpCTT9tMeta?.alias || [],
    redirect: bankrollIXXYpCTT9tMeta?.redirect,
    component: () => import("/app/pages/dashboard/bankroll.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___en",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/en/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___it",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/it/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___de",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/de/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___es",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/es/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___fr",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/fr/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___nl",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/nl/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___pt",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/pt/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___ru",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/ru/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: cashbackj9xLNvqGZJMeta?.name ?? "dashboard-cashback___uk",
    path: cashbackj9xLNvqGZJMeta?.path ?? "/uk/dashboard/cashback",
    meta: cashbackj9xLNvqGZJMeta || {},
    alias: cashbackj9xLNvqGZJMeta?.alias || [],
    redirect: cashbackj9xLNvqGZJMeta?.redirect,
    component: () => import("/app/pages/dashboard/cashback.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___en",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/en/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___it",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/it/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___de",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/de/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___es",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/es/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___fr",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/fr/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___nl",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/nl/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___pt",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/pt/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___ru",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/ru/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: contact_45requestsIlllfYP3BRMeta?.name ?? "dashboard-contact-requests___uk",
    path: contact_45requestsIlllfYP3BRMeta?.path ?? "/uk/dashboard/contact-requests",
    meta: contact_45requestsIlllfYP3BRMeta || {},
    alias: contact_45requestsIlllfYP3BRMeta?.alias || [],
    redirect: contact_45requestsIlllfYP3BRMeta?.redirect,
    component: () => import("/app/pages/dashboard/contact-requests.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___en",
    path: indexhg2nWJrbRRMeta?.path ?? "/en/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___it",
    path: indexhg2nWJrbRRMeta?.path ?? "/it/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___de",
    path: indexhg2nWJrbRRMeta?.path ?? "/de/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___es",
    path: indexhg2nWJrbRRMeta?.path ?? "/es/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___fr",
    path: indexhg2nWJrbRRMeta?.path ?? "/fr/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___nl",
    path: indexhg2nWJrbRRMeta?.path ?? "/nl/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___pt",
    path: indexhg2nWJrbRRMeta?.path ?? "/pt/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___ru",
    path: indexhg2nWJrbRRMeta?.path ?? "/ru/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexhg2nWJrbRRMeta?.name ?? "dashboard___uk",
    path: indexhg2nWJrbRRMeta?.path ?? "/uk/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    alias: indexhg2nWJrbRRMeta?.alias || [],
    redirect: indexhg2nWJrbRRMeta?.redirect,
    component: () => import("/app/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/en/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___en",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___en",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/it/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___it",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___it",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/de/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___de",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___de",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/es/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___es",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___es",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/fr/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___fr",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___fr",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/nl/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___nl",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___nl",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/pt/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___pt",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___pt",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/ru/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___ru",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___ru",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: job_45applicationsM6A7yqAKv1Meta?.name ?? undefined,
    path: job_45applicationsM6A7yqAKv1Meta?.path ?? "/uk/dashboard/job-applications",
    meta: job_45applicationsM6A7yqAKv1Meta || {},
    alias: job_45applicationsM6A7yqAKv1Meta?.alias || [],
    redirect: job_45applicationsM6A7yqAKv1Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93NsvpltuG43Meta?.name ?? "dashboard-job-applications-slug___uk",
    path: _91slug_93NsvpltuG43Meta?.path ?? ":slug()",
    meta: _91slug_93NsvpltuG43Meta || {},
    alias: _91slug_93NsvpltuG43Meta?.alias || [],
    redirect: _91slug_93NsvpltuG43Meta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVNjjcGZAndMeta?.name ?? "dashboard-job-applications___uk",
    path: indexVNjjcGZAndMeta?.path ?? "",
    meta: indexVNjjcGZAndMeta || {},
    alias: indexVNjjcGZAndMeta?.alias || [],
    redirect: indexVNjjcGZAndMeta?.redirect,
    component: () => import("/app/pages/dashboard/job-applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___en",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/en/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___it",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/it/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___de",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/de/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___es",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/es/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___fr",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/fr/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___nl",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/nl/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___pt",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/pt/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___ru",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/ru/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: _91invoiceCode_93Gkaf9unp4fMeta?.name ?? "dashboard-orders-invoiceCode___uk",
    path: _91invoiceCode_93Gkaf9unp4fMeta?.path ?? "/uk/dashboard/orders/:invoiceCode()",
    meta: _91invoiceCode_93Gkaf9unp4fMeta || {},
    alias: _91invoiceCode_93Gkaf9unp4fMeta?.alias || [],
    redirect: _91invoiceCode_93Gkaf9unp4fMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/[invoiceCode].vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___en",
    path: index2tHatxspqcMeta?.path ?? "/en/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___it",
    path: index2tHatxspqcMeta?.path ?? "/it/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___de",
    path: index2tHatxspqcMeta?.path ?? "/de/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___es",
    path: index2tHatxspqcMeta?.path ?? "/es/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___fr",
    path: index2tHatxspqcMeta?.path ?? "/fr/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___nl",
    path: index2tHatxspqcMeta?.path ?? "/nl/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___pt",
    path: index2tHatxspqcMeta?.path ?? "/pt/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___ru",
    path: index2tHatxspqcMeta?.path ?? "/ru/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index2tHatxspqcMeta?.name ?? "dashboard-orders___uk",
    path: index2tHatxspqcMeta?.path ?? "/uk/dashboard/orders",
    meta: index2tHatxspqcMeta || {},
    alias: index2tHatxspqcMeta?.alias || [],
    redirect: index2tHatxspqcMeta?.redirect,
    component: () => import("/app/pages/dashboard/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___en",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/en/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___it",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/it/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___de",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/de/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___es",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/es/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___fr",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/fr/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___nl",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/nl/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___pt",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/pt/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___ru",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/ru/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: _91raid_93fktTnM7vb9Meta?.name ?? "dashboard-raid-orders-date-raid___uk",
    path: _91raid_93fktTnM7vb9Meta?.path ?? "/uk/dashboard/raid-orders/:date()/:raid()",
    meta: _91raid_93fktTnM7vb9Meta || {},
    alias: _91raid_93fktTnM7vb9Meta?.alias || [],
    redirect: _91raid_93fktTnM7vb9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/[date]/[raid].vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___en",
    path: indexcJztBknFy9Meta?.path ?? "/en/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___it",
    path: indexcJztBknFy9Meta?.path ?? "/it/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___de",
    path: indexcJztBknFy9Meta?.path ?? "/de/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___es",
    path: indexcJztBknFy9Meta?.path ?? "/es/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___fr",
    path: indexcJztBknFy9Meta?.path ?? "/fr/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___nl",
    path: indexcJztBknFy9Meta?.path ?? "/nl/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___pt",
    path: indexcJztBknFy9Meta?.path ?? "/pt/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___ru",
    path: indexcJztBknFy9Meta?.path ?? "/ru/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexcJztBknFy9Meta?.name ?? "dashboard-raid-orders___uk",
    path: indexcJztBknFy9Meta?.path ?? "/uk/dashboard/raid-orders",
    meta: indexcJztBknFy9Meta || {},
    alias: indexcJztBknFy9Meta?.alias || [],
    redirect: indexcJztBknFy9Meta?.redirect,
    component: () => import("/app/pages/dashboard/raid-orders/index.vue").then(m => m.default || m)
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___en",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/en/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___en",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___en",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___en",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___en",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___en",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___en",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___en",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___en",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___en",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___en",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___en",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___en",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___it",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/it/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___it",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___it",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___it",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___it",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___it",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___it",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___it",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___it",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___it",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___it",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___it",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___it",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___de",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/de/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___de",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___de",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___de",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___de",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___de",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___de",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___de",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___de",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___de",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___de",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___de",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___de",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___es",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/es/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___es",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___es",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___es",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___es",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___es",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___es",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___es",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___es",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___es",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___es",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___es",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___es",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___fr",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/fr/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___fr",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___fr",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___fr",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___fr",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___fr",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___fr",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___fr",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___fr",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___fr",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___fr",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___fr",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___fr",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___nl",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/nl/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___nl",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___nl",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___nl",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___nl",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___nl",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___nl",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___nl",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___nl",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___nl",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___nl",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___nl",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___nl",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___pt",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/pt/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___pt",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___pt",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___pt",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___pt",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___pt",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___pt",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___pt",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___pt",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___pt",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___pt",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___pt",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___pt",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___ru",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/ru/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___ru",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___ru",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___ru",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___ru",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___ru",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___ru",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___ru",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___ru",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___ru",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___ru",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___ru",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___ru",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: user_45account_45settingsLd7K15ZzspMeta?.name ?? "dashboard-user-account-settings___uk",
    path: user_45account_45settingsLd7K15ZzspMeta?.path ?? "/uk/dashboard/user-account-settings",
    meta: user_45account_45settingsLd7K15ZzspMeta || {},
    alias: user_45account_45settingsLd7K15ZzspMeta?.alias || [],
    redirect: user_45account_45settingsLd7K15ZzspMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings.vue").then(m => m.default || m),
    children: [
  {
    name: admin_45goldaU8fc2VapkMeta?.name ?? "dashboard-user-account-settings-userId-admin-gold___uk",
    path: admin_45goldaU8fc2VapkMeta?.path ?? ":userId()/admin-gold",
    meta: admin_45goldaU8fc2VapkMeta || {},
    alias: admin_45goldaU8fc2VapkMeta?.alias || [],
    redirect: admin_45goldaU8fc2VapkMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-gold.vue").then(m => m.default || m)
  },
  {
    name: admin_45ip_45logsqxtTXqY1AjMeta?.name ?? "dashboard-user-account-settings-userId-admin-ip-logs___uk",
    path: admin_45ip_45logsqxtTXqY1AjMeta?.path ?? ":userId()/admin-ip-logs",
    meta: admin_45ip_45logsqxtTXqY1AjMeta || {},
    alias: admin_45ip_45logsqxtTXqY1AjMeta?.alias || [],
    redirect: admin_45ip_45logsqxtTXqY1AjMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-ip-logs.vue").then(m => m.default || m)
  },
  {
    name: admin_45levelsHkZdsNzffNMeta?.name ?? "dashboard-user-account-settings-userId-admin-levels___uk",
    path: admin_45levelsHkZdsNzffNMeta?.path ?? ":userId()/admin-levels",
    meta: admin_45levelsHkZdsNzffNMeta || {},
    alias: admin_45levelsHkZdsNzffNMeta?.alias || [],
    redirect: admin_45levelsHkZdsNzffNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-levels.vue").then(m => m.default || m)
  },
  {
    name: admin_45raid_45calenderLe4hPFZFL9Meta?.name ?? "dashboard-user-account-settings-userId-admin-raid-calender___uk",
    path: admin_45raid_45calenderLe4hPFZFL9Meta?.path ?? ":userId()/admin-raid-calender",
    meta: admin_45raid_45calenderLe4hPFZFL9Meta || {},
    alias: admin_45raid_45calenderLe4hPFZFL9Meta?.alias || [],
    redirect: admin_45raid_45calenderLe4hPFZFL9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/admin-raid-calender.vue").then(m => m.default || m)
  },
  {
    name: user_45accountvJ3OgBfyFIMeta?.name ?? "dashboard-user-account-settings-userId-user-account___uk",
    path: user_45accountvJ3OgBfyFIMeta?.path ?? ":userId()/user-account",
    meta: user_45accountvJ3OgBfyFIMeta || {},
    alias: user_45accountvJ3OgBfyFIMeta?.alias || [],
    redirect: user_45accountvJ3OgBfyFIMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-account.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45optionscRVj0PYmK9Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-options___uk",
    path: user_45booster_45optionscRVj0PYmK9Meta?.path ?? ":userId()/user-booster-options",
    meta: user_45booster_45optionscRVj0PYmK9Meta || {},
    alias: user_45booster_45optionscRVj0PYmK9Meta?.alias || [],
    redirect: user_45booster_45optionscRVj0PYmK9Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-options.vue").then(m => m.default || m)
  },
  {
    name: user_45booster_45profileDfGwWSAzC1Meta?.name ?? "dashboard-user-account-settings-userId-user-booster-profile___uk",
    path: user_45booster_45profileDfGwWSAzC1Meta?.path ?? ":userId()/user-booster-profile",
    meta: user_45booster_45profileDfGwWSAzC1Meta || {},
    alias: user_45booster_45profileDfGwWSAzC1Meta?.alias || [],
    redirect: user_45booster_45profileDfGwWSAzC1Meta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-booster-profile.vue").then(m => m.default || m)
  },
  {
    name: user_45connected_45accountsnyrGC4TIbNMeta?.name ?? "dashboard-user-account-settings-userId-user-connected-accounts___uk",
    path: user_45connected_45accountsnyrGC4TIbNMeta?.path ?? ":userId()/user-connected-accounts",
    meta: user_45connected_45accountsnyrGC4TIbNMeta || {},
    alias: user_45connected_45accountsnyrGC4TIbNMeta?.alias || [],
    redirect: user_45connected_45accountsnyrGC4TIbNMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-connected-accounts.vue").then(m => m.default || m)
  },
  {
    name: user_45membershipxMkSzFwqEAMeta?.name ?? "dashboard-user-account-settings-userId-user-membership___uk",
    path: user_45membershipxMkSzFwqEAMeta?.path ?? ":userId()/user-membership",
    meta: user_45membershipxMkSzFwqEAMeta || {},
    alias: user_45membershipxMkSzFwqEAMeta?.alias || [],
    redirect: user_45membershipxMkSzFwqEAMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-membership.vue").then(m => m.default || m)
  },
  {
    name: user_45securityqXUHCXG95oMeta?.name ?? "dashboard-user-account-settings-userId-user-security___uk",
    path: user_45securityqXUHCXG95oMeta?.path ?? ":userId()/user-security",
    meta: user_45securityqXUHCXG95oMeta || {},
    alias: user_45securityqXUHCXG95oMeta?.alias || [],
    redirect: user_45securityqXUHCXG95oMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-security.vue").then(m => m.default || m)
  },
  {
    name: user_45verificationkfFJhUf1cXMeta?.name ?? "dashboard-user-account-settings-userId-user-verification___uk",
    path: user_45verificationkfFJhUf1cXMeta?.path ?? ":userId()/user-verification",
    meta: user_45verificationkfFJhUf1cXMeta || {},
    alias: user_45verificationkfFJhUf1cXMeta?.alias || [],
    redirect: user_45verificationkfFJhUf1cXMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-verification.vue").then(m => m.default || m)
  },
  {
    name: user_45walletIqsgnPRxngMeta?.name ?? "dashboard-user-account-settings-userId-user-wallet___uk",
    path: user_45walletIqsgnPRxngMeta?.path ?? ":userId()/user-wallet",
    meta: user_45walletIqsgnPRxngMeta || {},
    alias: user_45walletIqsgnPRxngMeta?.alias || [],
    redirect: user_45walletIqsgnPRxngMeta?.redirect,
    component: () => import("/app/pages/dashboard/user-account-settings/[userId]/user-wallet.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___en",
    path: _91code_93AxIx7d4360Meta?.path ?? "/en/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___it",
    path: _91code_93AxIx7d4360Meta?.path ?? "/it/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___de",
    path: _91code_93AxIx7d4360Meta?.path ?? "/de/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___es",
    path: _91code_93AxIx7d4360Meta?.path ?? "/es/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___fr",
    path: _91code_93AxIx7d4360Meta?.path ?? "/fr/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___nl",
    path: _91code_93AxIx7d4360Meta?.path ?? "/nl/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___pt",
    path: _91code_93AxIx7d4360Meta?.path ?? "/pt/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___ru",
    path: _91code_93AxIx7d4360Meta?.path ?? "/ru/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93AxIx7d4360Meta?.name ?? "dashboard-verification-code___uk",
    path: _91code_93AxIx7d4360Meta?.path ?? "/uk/dashboard/verification/:code()",
    meta: _91code_93AxIx7d4360Meta || {},
    alias: _91code_93AxIx7d4360Meta?.alias || [],
    redirect: _91code_93AxIx7d4360Meta?.redirect,
    component: () => import("/app/pages/dashboard/verification/[code].vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___en",
    path: indexaIurtgxbffMeta?.path ?? "/en/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___it",
    path: indexaIurtgxbffMeta?.path ?? "/it/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___de",
    path: indexaIurtgxbffMeta?.path ?? "/de/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___es",
    path: indexaIurtgxbffMeta?.path ?? "/es/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___fr",
    path: indexaIurtgxbffMeta?.path ?? "/fr/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___nl",
    path: indexaIurtgxbffMeta?.path ?? "/nl/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___pt",
    path: indexaIurtgxbffMeta?.path ?? "/pt/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___ru",
    path: indexaIurtgxbffMeta?.path ?? "/ru/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: indexaIurtgxbffMeta?.name ?? "dashboard-verification___uk",
    path: indexaIurtgxbffMeta?.path ?? "/uk/dashboard/verification",
    meta: indexaIurtgxbffMeta || {},
    alias: indexaIurtgxbffMeta?.alias || [],
    redirect: indexaIurtgxbffMeta?.redirect,
    component: () => import("/app/pages/dashboard/verification/index.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___en",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/en/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___it",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/it/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___de",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/de/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___es",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/es/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___fr",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/fr/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___nl",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/nl/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___pt",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/pt/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___ru",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/ru/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: error_45page_45paymentxGcS47fXOJMeta?.name ?? "error-page-payment___uk",
    path: error_45page_45paymentxGcS47fXOJMeta?.path ?? "/uk/error-page-payment",
    meta: error_45page_45paymentxGcS47fXOJMeta || {},
    alias: error_45page_45paymentxGcS47fXOJMeta?.alias || [],
    redirect: error_45page_45paymentxGcS47fXOJMeta?.redirect,
    component: () => import("/app/pages/error-page-payment.vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___en",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/en/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___it",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/it/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___de",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/de/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___es",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/es/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___fr",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/fr/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___nl",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/nl/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___pt",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/pt/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___ru",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/ru/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: _91boosterId_930oZYfcOhHTMeta?.name ?? "gold-seller-boosterId___uk",
    path: _91boosterId_930oZYfcOhHTMeta?.path ?? "/uk/gold-seller/:boosterId()",
    meta: _91boosterId_930oZYfcOhHTMeta || {},
    alias: _91boosterId_930oZYfcOhHTMeta?.alias || [],
    redirect: _91boosterId_930oZYfcOhHTMeta?.redirect,
    component: () => import("/app/pages/gold-seller/[boosterId].vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___en",
    path: indexN6pT4Un8hYMeta?.path ?? "/en",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___it",
    path: indexN6pT4Un8hYMeta?.path ?? "/it",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___de",
    path: indexN6pT4Un8hYMeta?.path ?? "/de",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___es",
    path: indexN6pT4Un8hYMeta?.path ?? "/es",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___fr",
    path: indexN6pT4Un8hYMeta?.path ?? "/fr",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___nl",
    path: indexN6pT4Un8hYMeta?.path ?? "/nl",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___pt",
    path: indexN6pT4Un8hYMeta?.path ?? "/pt",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___ru",
    path: indexN6pT4Un8hYMeta?.path ?? "/ru",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___uk",
    path: indexN6pT4Un8hYMeta?.path ?? "/uk",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___en",
    path: link_45discordUagKM3akRfMeta?.path ?? "/en/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___it",
    path: link_45discordUagKM3akRfMeta?.path ?? "/it/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___de",
    path: link_45discordUagKM3akRfMeta?.path ?? "/de/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___es",
    path: link_45discordUagKM3akRfMeta?.path ?? "/es/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___fr",
    path: link_45discordUagKM3akRfMeta?.path ?? "/fr/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___nl",
    path: link_45discordUagKM3akRfMeta?.path ?? "/nl/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___pt",
    path: link_45discordUagKM3akRfMeta?.path ?? "/pt/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___ru",
    path: link_45discordUagKM3akRfMeta?.path ?? "/ru/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: link_45discordUagKM3akRfMeta?.name ?? "link-discord___uk",
    path: link_45discordUagKM3akRfMeta?.path ?? "/uk/link-discord",
    meta: link_45discordUagKM3akRfMeta || {},
    alias: link_45discordUagKM3akRfMeta?.alias || [],
    redirect: link_45discordUagKM3akRfMeta?.redirect,
    component: () => import("/app/pages/link-discord.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___en",
    path: loginhHM0vSTW5jMeta?.path ?? "/en/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___it",
    path: loginhHM0vSTW5jMeta?.path ?? "/it/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___de",
    path: loginhHM0vSTW5jMeta?.path ?? "/de/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___es",
    path: loginhHM0vSTW5jMeta?.path ?? "/es/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___fr",
    path: loginhHM0vSTW5jMeta?.path ?? "/fr/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___nl",
    path: loginhHM0vSTW5jMeta?.path ?? "/nl/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___pt",
    path: loginhHM0vSTW5jMeta?.path ?? "/pt/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___ru",
    path: loginhHM0vSTW5jMeta?.path ?? "/ru/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login___uk",
    path: loginhHM0vSTW5jMeta?.path ?? "/uk/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___en",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/en/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___it",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/it/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___de",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/de/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___es",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/es/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___fr",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/fr/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___nl",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/nl/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___pt",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/pt/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___ru",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/ru/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkout_45magiccQtY61111sMeta?.name ?? "membership-checkout-magic___uk",
    path: membership_45checkout_45magiccQtY61111sMeta?.path ?? "/uk/membership-checkout-magic",
    meta: membership_45checkout_45magiccQtY61111sMeta || {},
    alias: membership_45checkout_45magiccQtY61111sMeta?.alias || [],
    redirect: membership_45checkout_45magiccQtY61111sMeta?.redirect,
    component: () => import("/app/pages/membership-checkout-magic.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___en",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/en/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___it",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/it/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___de",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/de/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___es",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/es/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___fr",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/fr/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___nl",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/nl/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___pt",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/pt/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___ru",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/ru/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membership_45checkoutM4b6a2wcZNMeta?.name ?? "membership-checkout___uk",
    path: membership_45checkoutM4b6a2wcZNMeta?.path ?? "/uk/membership-checkout",
    meta: membership_45checkoutM4b6a2wcZNMeta || {},
    alias: membership_45checkoutM4b6a2wcZNMeta?.alias || [],
    redirect: membership_45checkoutM4b6a2wcZNMeta?.redirect,
    component: () => import("/app/pages/membership-checkout.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___en",
    path: membershipWWFsX1R3saMeta?.path ?? "/en/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___it",
    path: membershipWWFsX1R3saMeta?.path ?? "/it/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___de",
    path: membershipWWFsX1R3saMeta?.path ?? "/de/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___es",
    path: membershipWWFsX1R3saMeta?.path ?? "/es/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___fr",
    path: membershipWWFsX1R3saMeta?.path ?? "/fr/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___nl",
    path: membershipWWFsX1R3saMeta?.path ?? "/nl/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___pt",
    path: membershipWWFsX1R3saMeta?.path ?? "/pt/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___ru",
    path: membershipWWFsX1R3saMeta?.path ?? "/ru/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipWWFsX1R3saMeta?.name ?? "membership___uk",
    path: membershipWWFsX1R3saMeta?.path ?? "/uk/membership",
    meta: membershipWWFsX1R3saMeta || {},
    alias: membershipWWFsX1R3saMeta?.alias || [],
    redirect: membershipWWFsX1R3saMeta?.redirect,
    component: () => import("/app/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___en",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/en/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___it",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/it/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___de",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/de/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___es",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/es/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___fr",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/fr/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___nl",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/nl/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___pt",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/pt/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___ru",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/ru/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45failedfyVjkMyN2QMeta?.name ?? "payment-failed___uk",
    path: payment_45failedfyVjkMyN2QMeta?.path ?? "/uk/payment-failed",
    meta: payment_45failedfyVjkMyN2QMeta || {},
    alias: payment_45failedfyVjkMyN2QMeta?.alias || [],
    redirect: payment_45failedfyVjkMyN2QMeta?.redirect,
    component: () => import("/app/pages/payment-failed.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___en",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/en/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___it",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/it/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___de",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/de/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___es",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/es/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___fr",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/fr/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___nl",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/nl/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___pt",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/pt/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___ru",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/ru/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: payment_45successxSyLRJqw0cMeta?.name ?? "payment-success___uk",
    path: payment_45successxSyLRJqw0cMeta?.path ?? "/uk/payment-success",
    meta: payment_45successxSyLRJqw0cMeta || {},
    alias: payment_45successxSyLRJqw0cMeta?.alias || [],
    redirect: payment_45successxSyLRJqw0cMeta?.redirect,
    component: () => import("/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___en",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/en/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___it",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/it/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___de",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/de/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___es",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/es/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___fr",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/fr/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___nl",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/nl/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___pt",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/pt/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___ru",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/ru/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: refund_45policyWeRYySghLcMeta?.name ?? "refund-policy___uk",
    path: refund_45policyWeRYySghLcMeta?.path ?? "/uk/refund-policy",
    meta: refund_45policyWeRYySghLcMeta || {},
    alias: refund_45policyWeRYySghLcMeta?.alias || [],
    redirect: refund_45policyWeRYySghLcMeta?.redirect,
    component: () => import("/app/pages/refund-policy.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___en",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/en/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___it",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/it/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___de",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/de/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___es",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/es/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___fr",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/fr/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___nl",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/nl/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___pt",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/pt/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___ru",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/ru/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: trustpilot_45review1LZO0tWtVGMeta?.name ?? "trustpilot-review___uk",
    path: trustpilot_45review1LZO0tWtVGMeta?.path ?? "/uk/trustpilot-review",
    meta: trustpilot_45review1LZO0tWtVGMeta || {},
    alias: trustpilot_45review1LZO0tWtVGMeta?.alias || [],
    redirect: trustpilot_45review1LZO0tWtVGMeta?.redirect,
    component: () => import("/app/pages/trustpilot-review.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___en",
    path: applylgoRnC39vRMeta?.path ?? "/en/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___it",
    path: applylgoRnC39vRMeta?.path ?? "/it/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___de",
    path: applylgoRnC39vRMeta?.path ?? "/de/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___es",
    path: applylgoRnC39vRMeta?.path ?? "/es/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___fr",
    path: applylgoRnC39vRMeta?.path ?? "/fr/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___nl",
    path: applylgoRnC39vRMeta?.path ?? "/nl/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___pt",
    path: applylgoRnC39vRMeta?.path ?? "/pt/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___ru",
    path: applylgoRnC39vRMeta?.path ?? "/ru/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: applylgoRnC39vRMeta?.name ?? "work-with-us-slug-apply___uk",
    path: applylgoRnC39vRMeta?.path ?? "/uk/work-with-us/:slug()/apply",
    meta: applylgoRnC39vRMeta || {},
    alias: applylgoRnC39vRMeta?.alias || [],
    redirect: applylgoRnC39vRMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/apply.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___en",
    path: indexLmszu812hPMeta?.path ?? "/en/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___it",
    path: indexLmszu812hPMeta?.path ?? "/it/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___de",
    path: indexLmszu812hPMeta?.path ?? "/de/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___es",
    path: indexLmszu812hPMeta?.path ?? "/es/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___fr",
    path: indexLmszu812hPMeta?.path ?? "/fr/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___nl",
    path: indexLmszu812hPMeta?.path ?? "/nl/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___pt",
    path: indexLmszu812hPMeta?.path ?? "/pt/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___ru",
    path: indexLmszu812hPMeta?.path ?? "/ru/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLmszu812hPMeta?.name ?? "work-with-us-slug___uk",
    path: indexLmszu812hPMeta?.path ?? "/uk/work-with-us/:slug()",
    meta: indexLmszu812hPMeta || {},
    alias: indexLmszu812hPMeta?.alias || [],
    redirect: indexLmszu812hPMeta?.redirect,
    component: () => import("/app/pages/work-with-us/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___en",
    path: indexJZF1QpkjHuMeta?.path ?? "/en/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___it",
    path: indexJZF1QpkjHuMeta?.path ?? "/it/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___de",
    path: indexJZF1QpkjHuMeta?.path ?? "/de/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___es",
    path: indexJZF1QpkjHuMeta?.path ?? "/es/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___fr",
    path: indexJZF1QpkjHuMeta?.path ?? "/fr/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___nl",
    path: indexJZF1QpkjHuMeta?.path ?? "/nl/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___pt",
    path: indexJZF1QpkjHuMeta?.path ?? "/pt/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___ru",
    path: indexJZF1QpkjHuMeta?.path ?? "/ru/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexJZF1QpkjHuMeta?.name ?? "work-with-us___uk",
    path: indexJZF1QpkjHuMeta?.path ?? "/uk/work-with-us",
    meta: indexJZF1QpkjHuMeta || {},
    alias: indexJZF1QpkjHuMeta?.alias || [],
    redirect: indexJZF1QpkjHuMeta?.redirect,
    component: () => import("/app/pages/work-with-us/index.vue").then(m => m.default || m)
  }
]